
import React, { useEffect, useState } from "react";
import API from "../Services/PartyProduct";
import { ToastContainer, toast } from "react-toastify";

const ActivityType = ({ selectedActivityType, setSelectedActivityType, selectedActivityCenter }) => {

    const [activityType, setActivityType] = useState([]);
    const [error, setError] = useState(null);

    const handleChange = (e) => {
        setSelectedActivityType(e.target.value);
    };

    const bindActivityType = async () => {
        try {
             const location_id = Array.isArray(selectedActivityCenter)
                ? selectedActivityCenter.join(", ")
                : selectedActivityCenter;
            const isMultiple=location_id.length === 1 ? 0 : 1;
            const payload = {
                is_active: 1,
                location_id: location_id,
                //location_id: selectedActivityCenter,
                is_multiple:isMultiple
            };
            const response = await API.getActivityTypeList(payload);
            setActivityType(response?.data?.data || []);
            setError(null);
        } catch (error) {
            if (error.response?.status === 403) {
                window.location.replace("/Login");
            } else if (error.response?.status === 404) {
                toast.error("Requested resource not found.");
            } else {
                setError("Failed to fetch Activity Type.");
            }
        }
    };

    useEffect(() => {
        if (selectedActivityCenter!==undefined) {
            bindActivityType();
        } else {
            setActivityType([]);
        }
    }, [selectedActivityCenter]);

    return (
        <div className="row">
            <div className="col-md-12">
                <div className="form-group">
                    <label htmlFor="ddlActivityType">
                        Activity Type <span style={{ color: "red" }}>*</span>
                    </label>
                    <select
                        className="form-select"
                        id="ddlActivityType"
                        value={selectedActivityType || ""}
                        onChange={handleChange}
                        required
                        disabled={!selectedActivityCenter}
                    >
                        <option value="">Select</option>
                        {activityType.length > 0 ? (
                            activityType.map((item) => (
                                <option key={item.id} value={item.id}>
                                    {item.name}
                                </option>
                            ))
                        ) : (
                            <option disabled>No activity types available</option>
                        )}
                    </select>
                    {error && <p style={{ color: "red" }}>{error}</p>}
                </div>
            </div>
        </div>
    );
};

export default ActivityType;
